import * as Sentry from '@sentry/react';

export function ignoreVetaCenterConnection404Rule(event: Sentry.ErrorEvent) {
  const is404ErrorResponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/(\w|-){36}\/veta_center\/connection$/;
  const isFetchingVetaCenterConnection = regexp.test(requestUrl);

  return is404ErrorResponse && isGETRequest && isFetchingVetaCenterConnection;
}
